import { createI18n } from 'vue-i18n';
import de from './de.json';
import en from './en.json';

const supportedLocales = ['de', 'en'] as const;
type SupportedLocale = (typeof supportedLocales)[number];

const langTag = document.documentElement.lang.split('-')[0];
const locale: SupportedLocale = supportedLocales.includes(langTag as SupportedLocale)
    ? (langTag as SupportedLocale)
    : 'de';

export const i18n = createI18n<[typeof de], SupportedLocale>({
    legacy: false,
    locale,
    fallbackLocale: 'de',
    messages: { de, en },
});
